"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplayIndicator = void 0;
var _core = require("@dragon/core");
require("./Base.scss");
var _reddot = _interopRequireDefault(require("./reddot.svg"));
var _frame = _interopRequireDefault(require("./frame.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ReplayIndicator = exports.ReplayIndicator = /*#__PURE__*/_createClass(function ReplayIndicator(parent) {
  var _this = this;
  _classCallCheck(this, ReplayIndicator);
  _defineProperty(this, "_node", void 0);
  _defineProperty(this, "replayIcon", void 0);
  _defineProperty(this, "frame1", void 0);
  _defineProperty(this, "frame2", void 0);
  _defineProperty(this, "frame3", void 0);
  _defineProperty(this, "frame4", void 0);
  _defineProperty(this, "roundId", void 0);
  _defineProperty(this, "toggleChevrons", function (r) {
    if (r) {
      _this.frame1.style.display = "block";
      _this.frame2.style.display = "block";
      _this.frame3.style.display = "block";
      _this.frame4.style.display = "block";
    } else {
      _this.frame1.style.display = "none";
      _this.frame2.style.display = "none";
      _this.frame3.style.display = "none";
      _this.frame4.style.display = "none";
    }
  });
  _defineProperty(this, "toggleRoundId", function (r) {
    if (r) _this.roundId.style.display = "block";else _this.roundId.style.display = "none";
  });
  _defineProperty(this, "toggleIcon", function (r) {
    if (r) _this.replayIcon.style.display = "block";else _this.replayIcon.style.display = "none";
  });
  _defineProperty(this, "toggle", function (r) {
    if (r) _this._node.style.display = "block";else _this._node.style.display = "none";
  });
  this._node = document.createElement("div");
  this._node.className = "replay-indicator";
  parent.appendChild(this._node);
  this.replayIcon = document.createElement("div");
  this.replayIcon.className = "replay-icon";
  this.replayIcon.innerHTML = _reddot["default"];
  this.replayIcon.innerHTML += _core.CORE.translate("replayIconText");
  this._node.appendChild(this.replayIcon);
  this.roundId = document.createElement("div");
  this.roundId.className = "replay-round-id";
  this._node.appendChild(this.roundId);
  _core.CORE.subscribe("replay.roundId", function (e) {
    if (!e) _this.roundId.innerHTML = "";else _this.roundId.innerHTML = e;
  });
  this.frame1 = document.createElement("div");
  this.frame1.className = "frame1";
  this.frame1.innerHTML = _frame["default"];
  this._node.appendChild(this.frame1);
  this.frame2 = document.createElement("div");
  this.frame2.className = "frame2";
  this.frame2.innerHTML = _frame["default"];
  this._node.appendChild(this.frame2);
  this.frame3 = document.createElement("div");
  this.frame3.className = "frame3";
  this.frame3.innerHTML = _frame["default"];
  this._node.appendChild(this.frame3);
  this.frame4 = document.createElement("div");
  this.frame4.className = "frame4";
  this.frame4.innerHTML = _frame["default"];
  this._node.appendChild(this.frame4);
  _core.CORE.subscribe('replay.playingReplay', function (e) {
    return _this.toggle(e);
  });
  _core.CORE.subscribe('replay.showChevrons', function (e) {
    return _this.toggleChevrons(e);
  });
  _core.CORE.subscribe('replay.showIcon', function (e) {
    return _this.toggleIcon(e);
  });
  _core.CORE.subscribe('replay.showRoundId', function (e) {
    return _this.toggleRoundId(e);
  });
});
//# sourceMappingURL=ReplayIndicator.js.map